export type PulseTimeAllocation = Record<string, number>; // dynamic keys from backend

export type Pulse = {
    type: 'OOO' | 'PULSE' | 'NO_INFO' | 'SKIP' | 'FUTURE' | 'HOLIDAY' | 'TODAY' | 'NOT_ENABLED';
    text: string;
    date: string;
    id?: number;
    commentCount?: number;
    prsCreated?: any[];
    prsMerged?: any[];
    editMode?: boolean;
    newText?: string;
    timeAllocation?: PulseTimeAllocation | null;
};

export type PulseData = {
    [date: string]: Pulse;
}

export type CompanyPulseData = {
    user: any,
    pulses: PulseData,
}

export type BaseUserData = {
    id: number;
    name: string;
}

export type Team = {
    id: number;
    name: string;
    slug: string;
    isActive: boolean;
}

export type UserWithTeam = BaseUserData & {
    username?: string;
    email?: string;
    teamId?: number;
    teamObj?: Team;
}

export type CheckinData = {
    id: number;
    leader: BaseUserData;
    happiness: number;
    productivity: number;
    passion: number;
    comment: string;
}

export type Department = {
    id: number;
    name: string;
}

export type Person = {
    id: number;
    name: string;
    email: string;
    username: string;
    profile: string;
    team?: string; // Legacy team field
    teamId?: number; // New team ID
    teamObj?: Team; // New team object
    department?: Department;
}

export type CoreValue = {
    key: string;
    name: string;
}

export type Shoutout = {
    id: number;
    from: Person;
    receivers: number[];
    coreValues: string[];
    why: string;
    delivery: string;
}

export enum OfficeLocation {
    US = 'US',
    UA = 'UA',
    PL = 'PL',
    DE = 'DE',
    TH = 'TH',
    PT = 'PT'
}
export type Holiday = {
    id: number;
    year: number;
    date: string;
    name: string;
    location: OfficeLocation;
}

